import * as React from 'react';
import { Route, Routes } from 'react-router';
import PageLayout from 'v2/layout/PageLayout/PageLayout';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import Overview from './Overview/Overview';

const Events: React.FC = () => (
  <PageLayout>
    <Routes>
      <Route path="/" element={<Overview />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </PageLayout>
);

export default Events;
